import { Link } from "wouter";
import { getCompanyContactLines } from "@/lib/company-info";

export function Footer() {
  return (
    <footer className="bg-bauwerk-teal text-white py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">BauwerkPlus</h3>
            <p className="text-bauwerk-mint text-sm">
              Ihr Partner für nachhaltige Betonsanierung und Oberflächenpflege
            </p>
          </div>
          
          <div>
            <h4 className="text-md font-semibold mb-3">Kontakt</h4>
            <div className="text-bauwerk-mint text-sm space-y-1">
              {getCompanyContactLines().map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="text-md font-semibold mb-3">Rechtliches</h4>
            <div className="text-bauwerk-mint text-sm space-y-2">
              <div>
                <a 
                  href="https://www.bauwerkplus.at/impressum/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Impressum
                </a>
              </div>
              <div>
                <a 
                  href="https://www.bauwerkplus.at/datenschutzerklaerung/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Datenschutz
                </a>
              </div>
              <div>
                <a 
                  href="https://www.bauwerkplus.at/cookie-richtlinie-eu/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Cookie-Richtlinie
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-6 border-t border-bauwerk-mint/30">
          <div className="flex flex-col items-center mb-6 gap-4">
            <p className="text-white font-bold text-xl tracking-wide">Gemeinsam stark</p>
            <div className="bg-[hsl(45,30%,93%)] rounded-2xl px-10 py-8 flex flex-wrap items-center justify-center gap-12">
              <img
                src="https://image-linker--hoferdruck9871.replit.app/objects/uploads/d377edc0-d3a9-43c3-b73a-4f07cc036860"
                alt="Hofer Fassade & Betonsanierung"
                className="h-20 w-auto object-contain"
              />
              <img
                src="https://image-linker--hoferdruck9871.replit.app/objects/uploads/dab44326-1652-4af8-b5c7-a3a7eeb1aa3f"
                alt="Maler Ortner GmbH"
                className="h-20 w-auto object-contain"
              />
            </div>
          </div>
          <div className="text-center">
            <p className="text-bauwerk-mint text-sm">
              © 2025 BauwerkPlus. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}